import React from "react";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import { Supplier } from "../../interfaces";

interface IProps {
  expensesFilterTerm: string;
  setExpensesFilterTerm: React.Dispatch<React.SetStateAction<string>>;
  suppliers: Supplier[];
}

export const ExpensesFilter = ({
  expensesFilterTerm,
  setExpensesFilterTerm,
  suppliers,
}: IProps) => {
  const handleChange = (event: SelectChangeEvent) => {
    setExpensesFilterTerm(event.target.value as string);
  };

  return (
    <Grid item xs={12} md={4} sx={{ margin: "0 5% 0  auto" }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Suvlasnik</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={expensesFilterTerm}
          label="Suvlasnik"
          onChange={handleChange}
        >
          <MenuItem value={"Svi"}>Svi</MenuItem>
          {suppliers.map((supplier: Supplier) => (
            <MenuItem value={supplier.id} key={supplier.id}>
              {supplier.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
};
